interface LedgerToolbarProps {
  search: string;
  onSearchChange: (value: string) => void;
  filteredCount: number;
  totalCount: number;
}

/**
 * The ledger card's header row — v6 `.ledger-meta` (SCRUM-353): search box +
 * "{filtered} of {total}" counter, left-aligned INSIDE the card with a bottom
 * border (10px 16px padding). The Product Insights / Start campaign buttons
 * moved OUT to the page-level utility strip above the card (v6
 * `.campaigns-utility`) — they are no longer this component's concern.
 */
export function LedgerToolbar({
  search,
  onSearchChange,
  filteredCount,
  totalCount,
}: LedgerToolbarProps) {
  return (
    <div className="border-border-0 flex items-center gap-3 border-b px-4 py-2.5">
      {/* .ledger-meta__search — a div wrapper (not the shadcn Input): 28px tall,
          240px wide, bg-3, border-0, rounded-md; focus → brand border + bg-4. */}
      <div className="border-border-0 bg-bg-3 rounded-tk-md focus-within:border-brand-primary focus-within:bg-bg-4 flex h-7 w-60 flex-shrink-0 items-center gap-1.5 border px-2.5">
        <svg
          viewBox="0 0 16 16"
          width="13"
          height="13"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          className="text-text-3 flex-shrink-0"
          aria-hidden="true"
        >
          <circle cx="7" cy="7" r="4" />
          <line x1="10" y1="10" x2="13.5" y2="13.5" />
        </svg>
        <input
          type="search"
          value={search}
          onChange={(e) => {
            onSearchChange(e.target.value);
          }}
          placeholder="Find customer…"
          aria-label="Find customer"
          className="text-text-0 placeholder:text-text-3 min-w-0 flex-1 border-0 bg-transparent text-xs outline-none"
        />
      </div>
      {/* .ledger-meta__count — text-3 0.6875rem with mono text-1 strong numbers. */}
      <p className="text-text-3 text-[0.6875rem] tracking-[0.02em]">
        <strong className="text-text-1 font-mono text-xs font-medium tracking-normal">
          {filteredCount.toLocaleString('en-US')}
        </strong>{' '}
        of{' '}
        <strong className="text-text-1 font-mono text-xs font-medium tracking-normal">
          {totalCount.toLocaleString('en-US')}
        </strong>{' '}
        customers
      </p>
    </div>
  );
}
